import { DivProps, Div, List, ListItem, P, Span } from '@kizi/core-components';
import React, { useRef } from 'react';
import { withExpandable, IconV2 } from '@kizi/shared-components';

export interface TermsListProps extends DivProps {
  terms?: string;
  termsArray?: string;
  expandableLabel?: string;
}

interface CarretProps {
  isCarretVisible: boolean;
}

export const TermsList: React.FC<TermsListProps> = ({
  terms,
  termsArray,
  expandableLabel,
  ...restProps
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const termsParsed = termsArray ? JSON.parse(termsArray) : undefined;
  const content = termsParsed ? (
    <Div ml={6}>
      <List variant="termsList">
        {termsParsed?.map((item) => {
          return (
            <ListItem display="flex" alignItems="center">
              <IconV2 name="document" size={24} />
              <P fontSize={3} dangerouslySetInnerHTML={{ __html: item }}></P>
            </ListItem>
          );
        })}
      </List>
    </Div>
  ) : (
    <Div
      css={{ '& ul': { paddingLeft: '40px' } }}
      dangerouslySetInnerHTML={{ __html: terms ? terms : '' }}
    ></Div>
  );
  const ExpandableDiv = withExpandable<DivProps, HTMLDivElement>(Div);
  const Carret: React.FC<CarretProps> = ({ isCarretVisible }) => {
    return (
      <IconV2 name={`big-arrow-${isCarretVisible ? 'up' : 'down'}`} size={16} />
    );
  };
  const children = (isExpanded: boolean) => {
    return (
      <P
        display="flex"
        alignItems="center"
        style={{ cursor: 'pointer' }}
        width="fit-content"
      >
        <Span ml={6} fontSize={3}>
          {expandableLabel ? expandableLabel : 'Bekijk alle voorwaarden'}
        </Span>
        <Carret isCarretVisible={isExpanded} />
      </P>
    );
  };
  return (
    <Div>
      <ExpandableDiv
        variant="termsListWrapper"
        ref={ref}
        _content={content}
        {...restProps}
        height="fit-content"
        mb={0}
      >
        {children}
      </ExpandableDiv>
    </Div>
  );
};
